// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.emailverification.RentalManagerUserEmailVerificationWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  EmailVerificationType,
  ListingAlias,
  RentalManagerContactEmailVerificationCodeValidationDto,
  RentalManagerContactEmailVerificationEmailVerificationDto,
  RentalManagerVerificationEmailUnverifiedEmailListingsDto,
  UserEmailVerificationSendSecurityTokenResponseWebDto,
  UserEmailVerificationVerifySecurityTokenResponseWebDto,
} from '../..';

interface GetUnverifiedEmailListingsParams {
  limit?: number;
}
interface SendSecurityTokenParams {
  email?: string;
  emailVerificationType?: EmailVerificationType;
  successRedirectPath?: string;
}
interface SendVerificationCodeParams {
  email: string;
  listingAlias: ListingAlias;
}
interface ValidateVerificationCodeParams {
  email: string;
  listingAlias: ListingAlias;
  verificationCode: string;
}
interface VerifySecurityTokenParams {
  securityToken: string;
}

export const RentalManagerUserEmailVerificationWebApiHandler_getUnverifiedEmailListings_Path =
  '/api/web/v1/users/emailVerification/getUnverifiedEmailListings';

/**
 * Get list of claimable listings if this user has an unverified email address
 */
export const RentalManagerUserEmailVerificationWebApiHandler_getUnverifiedEmailListings = (
  getParams: GetUnverifiedEmailListingsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    GetUnverifiedEmailListingsParams,
    never,
    RentalManagerVerificationEmailUnverifiedEmailListingsDto
  >(
    {
      getParams: getParams,
      endpoint: RentalManagerUserEmailVerificationWebApiHandler_getUnverifiedEmailListings_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserEmailVerificationWebApiHandler_sendSecurityToken_Path =
  '/api/web/v1/users/emailVerification/sendSecurityToken';

/**
 * Email the email verification link to the user
 */
export const RentalManagerUserEmailVerificationWebApiHandler_sendSecurityToken = (
  getParams: SendSecurityTokenParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<SendSecurityTokenParams, never, UserEmailVerificationSendSecurityTokenResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserEmailVerificationWebApiHandler_sendSecurityToken_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserEmailVerificationWebApiHandler_sendVerificationCode_Path =
  '/api/web/v1/users/emailVerification/sendVerificationCode';

/**
 * Email the contact email verification code to the user
 */
export const RentalManagerUserEmailVerificationWebApiHandler_sendVerificationCode = (
  getParams: SendVerificationCodeParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    SendVerificationCodeParams,
    never,
    RentalManagerContactEmailVerificationEmailVerificationDto
  >(
    {
      getParams: getParams,
      endpoint: RentalManagerUserEmailVerificationWebApiHandler_sendVerificationCode_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserEmailVerificationWebApiHandler_validateVerificationCode_Path =
  '/api/web/v1/users/emailVerification/validateVerificationCode';

/**
 * Validate code for contact email verification
 */
export const RentalManagerUserEmailVerificationWebApiHandler_validateVerificationCode = (
  getParams: ValidateVerificationCodeParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    ValidateVerificationCodeParams,
    never,
    RentalManagerContactEmailVerificationCodeValidationDto
  >(
    {
      getParams: getParams,
      endpoint: RentalManagerUserEmailVerificationWebApiHandler_validateVerificationCode_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserEmailVerificationWebApiHandler_verifySecurityToken_Path =
  '/api/web/v1/users/emailVerification/verifySecurityToken';

/**
 * Verify securityToken from email verification
 */
export const RentalManagerUserEmailVerificationWebApiHandler_verifySecurityToken = (
  getParams: VerifySecurityTokenParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<VerifySecurityTokenParams, never, UserEmailVerificationVerifySecurityTokenResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserEmailVerificationWebApiHandler_verifySecurityToken_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
